import { useState, useEffect, useMemo, memo } from "react";
import { useSelector, NavLink, titleToUrl } from "../../imports/generalImport";
import { Container, Skeleton, Box, useMediaQuery } from "../../imports/muiImport";
import Slider from "react-slick";
import './homeslider.css';



const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    swipeToSlide: true,
    touchThreshold: 10,
    lazyLoad: 'ondemand',
    mobileFirst: true,
    arrows: false,
};

const Index = ({ height = 181, dots = false }) => {
    const sliderData = useSelector((state) => state?.MobileHomepage?.allData);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [filteredSliders, setFilteredSliders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        try {
            const sliders = isMobile ? sliderData?.SliderMobile : sliderData?.sliders;
            setFilteredSliders(sliders?.filter(item => item && (isMobile ? item.mobileSliderImage : item.image)));
        } catch (error) {
            console.error('Slider data processing error:', error);
        } finally {
            setIsLoading(false);
        }
    }, [isMobile, sliderData]);

    const settings = useMemo(() => ({
        ...sliderSettings,
        dots,
        cssEase: 'ease-out',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    speed: 300,
                    touchThreshold: 15,
                }
            }
        ]
    }), [dots]);

    return (
        <Container
            maxWidth="false"
            disableGutters
            className="slider-container"
            sx={{
                position: 'relative',
                mb: { xs: 2, sm: 3 },
                userSelect: 'none',
                touchAction: 'pan-y',
                position: 'relative',
                "& .slick-dots": {
                    zIndex: 0,
                },
                "& .slick-dots > li button:before": {
                    fontSize: 12,
                    borderRadius: "50%",
                    outline: "1px solid #002865",
                    backgroundColor: 'transparent',

                },
            }}
        >
            {isLoading || !filteredSliders?.length ? (
                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    width="100%"
                    sx={{
                        height: {
                            xs: height,
                            sm: '260px',
                            md: '320px',
                            lg: '390px',
                            xl: '380px'
                        },
                        borderRadius: { xs: 2, sm: 0 },
                    }}
                />
            ) : (
                filteredSliders?.length > 1 ?
                    <Slider {...settings}>
                            {filteredSliders.map((item) => {
                                const customURL = `${item?.url}${item?.url_utm ? `?${item?.url_utm}` : ''}`;

                                return (
                                    item?.url ? (
                                        <NavLink to={customURL} key={`hero-slider-${item.url}`} style={{ display: 'block' }}>
                                            <SliderImage item={item} height={height} isMobile={isMobile} />
                                        </NavLink>
                                    ) : (
                                        <SliderImage
                                            item={item}
                                            height={height}
                                            key={`hero-slider-${item.url || Math.random()}`}
                                            isMobile={isMobile}
                                        />
                                    )
                                )
                            })}
                    </Slider>
                    :
                    filteredSliders.map((item) => {
                        const customURL = `${item?.url}${item?.url_utm ? `?${item?.url_utm}` : ''}`;

                        return (
                            item?.url ? (
                                <NavLink to={customURL} key={`hero-slider-${item.url}`} style={{ display: 'block' }} >
                                    <SliderImage item={item} height={height} isMobile={isMobile} />
                                </NavLink>
                            ) : (
                                <SliderImage
                                    item={item}
                                    height={height}
                                    key={`hero-slider-${item.url || Math.random()}`}
                                    isMobile={isMobile}
                                />
                            )
                        )
                    })
            )}
        </Container>
    );
};



const SliderImage = memo(({ item, height, isMobile }) => {
    const imageSrc = useMemo(() =>
        isMobile ? item.mobileSliderImage : item.image,
        [isMobile, item]
    );

    return (
        <Box
            component="img"
            src={imageSrc}
            alt={`${item?.title || 'slider'}-99gift-hero-sliders`}
            loading="lazy"
            sx={{
                width: {
                    xs: '100%',
                    lg: '100%'
                },
                height: {
                    xs: height,
                    sm: 'auto',
                    md: 'auto',
                    lg: 'auto',
                },
                objectFit: { sm: 'contain', lg: 'cover' },
                objectPosition: 'center',
                borderRadius: { xs: 2, sm: 0 },
                backgroundColor: { xs: 'white.main', sm: 'backgroundPrimary.main' },
                userSelect: 'none',
                pointerEvents: 'none',
                '&.lazyloaded': {
                    transition: 'opacity 0.3s ease-in',
                }
            }}
        />
    );
});

export default memo(Index);